import { types } from 'mobx-state-tree';

export default types.model('WindowSize', {
  width: 0,
  height: 0,
});
